import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Delays Report Table component
 */
export const reportTableStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  tableContainer: {
    width: "100%",
    height: "calc(100% - 20px)",
  },
  gridWrapper: {
    padding: "10px",
    height: "calc(100vh - 300px)",
    minHeight: "calc(100vh - 300px)",
    width: "100%",
  },
});
